// countrycode + number
export const phoneREGEX = new RegExp(
  /^(?:\+\d{1,3}|0\d{1,3}|00\d{1,2})?(?:\s?\(\d+\))?(?:[-\/\s.]|\d)+$/
);

export const validationErrorMessage = (field, message = "This field is required!") => {
  if (field) {
    return (
      <small style={{ color: "#e74c3c" }} className="error-text d-block mb-2">
        {message}
      </small>
    );
  }
};

export const options = {
  tier1: {
    validationMessages: {
      options: "You must choose at least one option",
      phone: "You must add a valid phone number",
      country: "You must select a country",
      name: "You must add your full name",
      phoneInvalid: "You must enter a valid phone number"
    }
  },
  tier2: {
    validationMessages: {
      age: "You must enter your age",
      about: "You must enter something about yourself",
      language: "You must select at least one language",
      interests: "You must select at least one interest",
      academic: "You must choose your academic",
      jobStatus: "You must select your job status",
      socialMediaReach: "You must select a social media reach"
    }
  },
  dropdownStyle: {
    background: "#fff",
    borderColor: "transparent",
    color: "#000",
    lineHeight: "normal",
    width: "400px",
    height: "70px"
  }
};

export const academic = [
  {
    value: "No degree",
    label: "No degree"
  },
  {
    value: "High school diploma",
    label: "High school diploma"
  },
  {
    value: "Associate's diploma",
    label: "Associate's diploma"
  },
  {
    value: "Bachelor's diploma",
    label: "Bachelor's diploma"
  },
  {
    value: "Masters diploma",
    label: "Masters diploma"
  },
  {
    value: "PhD diploma",
    label: "PhD diploma"
  },
  {
    value: "Doctoral diploma",
    label: "Doctoral diploma"
  }
];

export const jobStatus = [
  {
    value: "Unemployed",
    label: "Unemployed"
  },
  {
    value: "Employee",
    label: "Employee"
  },
  {
    value: "Self-employed",
    label: "Self-employed"
  },
  {
    value: "Freelancer",
    label: "Freelancer"
  },
  {
    value: "Investor",
    label: "Investor"
  }
];

export const socialMediaReach = [
  {
    value: "500",
    label: "0 - 500"
  },
  {
    value: "1000",
    label: "500 - 1000"
  },
  {
    value: "5000",
    label: "1000 - 5000"
  },
  {
    value: "10000",
    label: "5000 - 10.000"
  },
  {
    value: "20000",
    label: "10.000 - 20.000"
  },
  {
    value: "50000",
    label: "20.000 - 50.000"
  },
  {
    value: "100000",
    label: "50.000 - 100.000"
  },
  {
    value: "100001",
    label: "Over 100.000"
  }
];

export const socialMediaList = [
  {
    value: "Facebook",
    label: "Facebook"
  },
  {
    value: "YouTube",
    label: "YouTube"
  },
  {
    value: "WhatsApp",
    label: "WhatsApp"
  },
  {
    value: "Instagram",
    label: "Instagram"
  },
  {
    value: "WeChat",
    label: "WeChat"
  },
  {
    value: "TikTok",
    label: "TikTok"
  },
  {
    value: "Telegram",
    label: "Telegram"
  },
  {
    value: "Snapchat",
    label: "Snapchat"
  },
  {
    value: "Twitter",
    label: "Twitter"
  },
  {
    value: "Reddit",
    label: "Reddit"
  },
  {
    value: "Quora",
    label: "Quora"
  },
  {
    value: "Skype",
    label: "Skype"
  },
  {
    value: "Linkedin",
    label: "LinkedIn"
  },
  {
    value: "Weibo",
    label: "Weibo"
  },
  {
    value: "Discord",
    label: "Discord"
  }
];

export const totalSalesExperience = [
  {
    value: "2",
    label: "1 - 2 years"
  },
  {
    value: "5",
    label: "2 - 5 years"
  },
  {
    value: "5-10",
    label: "5 - 10 years"
  },
  {
    value: "10-15",
    label: "10 - 15 years"
  },
  {
    value: "15",
    label: "Over 15 years"
  }
];

export const totalSalesVolume = [
  {
    value: "1000",
    label: "$100 - $1.000"
  },
  {
    value: "5000",
    label: "$1.000 - $5.000"
  },
  {
    value: "10000",
    label: "$5.000 - $10.000"
  },
  {
    value: "20000",
    label: "$10.000 - $20.000"
  },
  {
    value: "50000",
    label: "$20.000 - $50.000"
  },
  {
    value: "100000",
    label: "$50.000 - $100.000"
  },
  {
    value: "500000",
    label: "$100.000 - $500.000"
  },
  {
    value: "500001",
    label: "Over $500.000"
  }
];

export const languages = [
  {
    value: "English",
    label: "English"
  },
  {
    value: "French",
    label: "Français"
  },
  {
    value: "German",
    label: "Deutsch"
  },
  {
    value: "Spanish",
    label: "Español"
  },
  {
    value: "Hindi",
    label: "Hindi"
  },
  {
    value: "Turkish",
    label: "Türk"
  },
  {
    value: "Romanian",
    label: "Română"
  },
  {
    value: "Russian",
    label: "русский"
  },
  {
    value: "Chinese",
    label: "中國人"
  },
  {
    value: "Vietnamese",
    label: "Tiếng Việt"
  },
  {
    value: "Arabic",
    label: "عربي"
  },
  {
    value: "Thailandese",
    label: "ไทย"
  }
];

export const interests = [
  {
    value: "Blockchain",
    label: "Blockchain"
  },
  {
    value: "Cybersecurity",
    label: "Cybersecurity"
  },
  {
    value: "Sales",
    label: "Sales"
  },
  {
    value: "Marketing",
    label: "Marketing"
  },
  {
    value: "Networking",
    label: "Networking"
  },
  {
    value: "Business",
    label: "Business"
  },
  {
    value: "Mining",
    label: "Mining"
  }
];

export const countries = [
  { value: "🇦🇼 Aruba", label: "🇦🇼 Aruba" },
  {
    value: "Afghanistan",
    label: "🇦🇫 Afghanistan"
  },
  {
    value: "Angola",
    label: "🇦🇴 Angola"
  },
  {
    value: "Anguilla",
    label: "🇦🇮 Anguilla"
  },
  {
    value: "Åland Islands",
    label: "🇦🇽 Åland Islands"
  },
  {
    value: "Albania",
    label: "🇦🇱 Albania"
  },
  {
    value: "Andorra",
    label: "🇦🇩 Andorra"
  },
  {
    value: "United Arab Emirates",
    label: "🇦🇪 United Arab Emirates"
  },
  {
    value: "Argentina",
    label: "🇦🇷 Argentina"
  },
  {
    value: "Armenia",
    label: "🇦🇲 Armenia"
  },
  {
    value: "American Samoa",
    label: "🇦🇸 American Samoa"
  },
  {
    value: "Antarctica",
    label: "🇦🇶 Antarctica"
  },
  {
    value: "French Southern and Antarctic Lands",
    label: "🇹🇫 French Southern and Antarctic Lands"
  },
  {
    value: "Antigua and Barbuda",
    label: "🇦🇬 Antigua and Barbuda"
  },
  {
    value: "Australia",
    label: "🇦🇺 Australia"
  },
  {
    value: "Austria",
    label: "🇦🇹 Austria"
  },
  {
    value: "Azerbaijan",
    label: "🇦🇿 Azerbaijan"
  },
  {
    value: "Burundi",
    label: "🇧🇮 Burundi"
  },
  {
    value: "Belgium",
    label: "🇧🇪 Belgium"
  },
  {
    value: "Benin",
    label: "🇧🇯 Benin"
  },
  {
    value: "Burkina Faso",
    label: "🇧🇫 Burkina Faso"
  },
  {
    value: "Bangladesh",
    label: "🇧🇩 Bangladesh"
  },
  {
    value: "Bulgaria",
    label: "🇧🇬 Bulgaria"
  },
  {
    value: "Bahrain",
    label: "🇧🇭 Bahrain"
  },
  {
    value: "Bahamas",
    label: "🇧🇸 Bahamas"
  },
  {
    value: "Bosnia and Herzegovina",
    label: "🇧🇦 Bosnia and Herzegovina"
  },
  {
    value: "Saint Barthélemy",
    label: "🇧🇱 Saint Barthélemy"
  },
  {
    value: "Saint Helena, Ascension and Tristan da Cunha",
    label: "🇸🇭 Saint Helena, Ascension and Tristan da Cunha"
  },
  {
    value: "Belarus",
    label: "🇧🇾 Belarus"
  },
  {
    value: "Belize",
    label: "🇧🇿 Belize"
  },
  {
    value: "Bermuda",
    label: "🇧🇲 Bermuda"
  },
  {
    value: "Bolivia",
    label: "🇧🇴 Bolivia"
  },
  {
    value: "Caribbean Netherlands",
    label: "🇳🇱 Caribbean Netherlands"
  },
  {
    value: "Brazil",
    label: "🇧🇷 Brazil"
  },
  {
    value: "Barbados",
    label: "🇧🇧 Barbados"
  },
  {
    value: "Brunei",
    label: "🇧🇳 Brunei"
  },
  {
    value: "Bhutan",
    label: "🇧🇹 Bhutan"
  },
  {
    value: "Bouvet Island",
    label: "🇧🇻 Bouvet Island"
  },
  {
    value: "Botswana",
    label: "🇧🇼 Botswana"
  },
  {
    value: "Central African Republic",
    label: "🇨🇫 Central African Republic"
  },
  {
    value: "Canada",
    label: "🇨🇦 Canada"
  },
  {
    value: "Cocos (Keeling) Islands",
    label: "🇨🇨 Cocos (Keeling) Islands"
  },
  {
    value: "Switzerland",
    label: "🇨🇭 Switzerland"
  },
  {
    value: "Chile",
    label: "🇨🇱 Chile"
  },
  {
    value: "China",
    label: "🇨🇳 China"
  },
  {
    value: "Ivory Coast",
    label: "🇨🇮 Ivory Coast"
  },
  {
    value: "Cameroon",
    label: "🇨🇲 Cameroon"
  },
  {
    value: "DR Congo",
    label: "🇨🇩 DR Congo"
  },
  {
    value: "Republic of the Congo",
    label: "🇨🇬 Republic of the Congo"
  },
  {
    value: "Cook Islands",
    label: "🇨🇰 Cook Islands"
  },
  {
    value: "Colombia",
    label: "🇨🇴 Colombia"
  },
  {
    value: "Comoros",
    label: "🇰🇲 Comoros"
  },
  {
    value: "Cape Verde",
    label: "🇨🇻 Cape Verde"
  },
  {
    value: "Costa Rica",
    label: "🇨🇷 Costa Rica"
  },
  {
    value: "Cuba",
    label: "🇨🇺 Cuba"
  },
  {
    value: "Curaçao",
    label: "🇨🇼 Curaçao"
  },
  {
    value: "Christmas Island",
    label: "🇨🇽 Christmas Island"
  },
  {
    value: "Cayman Islands",
    label: "🇰🇾 Cayman Islands"
  },
  {
    value: "Cyprus",
    label: "🇨🇾 Cyprus"
  },
  {
    value: "Czechia",
    label: "🇨🇿 Czechia"
  },
  {
    value: "Germany",
    label: "🇩🇪 Germany"
  },
  {
    value: "Djibouti",
    label: "🇩🇯 Djibouti"
  },
  {
    value: "Dominica",
    label: "🇩🇲 Dominica"
  },
  {
    value: "Denmark",
    label: "🇩🇰 Denmark"
  },
  {
    value: "Dominican Republic",
    label: "🇩🇴 Dominican Republic"
  },
  {
    value: "Algeria",
    label: "🇩🇿 Algeria"
  },
  {
    value: "Ecuador",
    label: "🇪🇨 Ecuador"
  },
  {
    value: "Egypt",
    label: "🇪🇬 Egypt"
  },
  {
    value: "Eritrea",
    label: "🇪🇷 Eritrea"
  },
  {
    value: "Western Sahara",
    label: "🇪🇭 Western Sahara"
  },
  {
    value: "Spain",
    label: "🇪🇸 Spain"
  },
  {
    value: "Estonia",
    label: "🇪🇪 Estonia"
  },
  {
    value: "Ethiopia",
    label: "🇪🇹 Ethiopia"
  },
  {
    value: "Finland",
    label: "🇫🇮 Finland"
  },
  {
    value: "Fiji",
    label: "🇫🇯 Fiji"
  },
  {
    value: "Falkland Islands",
    label: "🇫🇰 Falkland Islands"
  },
  {
    value: "France",
    label: "🇫🇷 France"
  },
  {
    value: "Faroe Islands",
    label: "🇫🇴 Faroe Islands"
  },
  {
    value: "Micronesia",
    label: "🇫🇲 Micronesia"
  },
  {
    value: "Gabon",
    label: "🇬🇦 Gabon"
  },
  {
    value: "United Kingdom",
    label: "🇬🇧 United Kingdom"
  },
  {
    value: "Georgia",
    label: "🇬🇪 Georgia"
  },
  {
    value: "Guernsey",
    label: "🇬🇬 Guernsey"
  },
  {
    value: "Ghana",
    label: "🇬🇭 Ghana"
  },
  {
    value: "Gibraltar",
    label: "🇬🇮 Gibraltar"
  },
  {
    value: "Guinea",
    label: "🇬🇳 Guinea"
  },
  {
    value: "Guadeloupe",
    label: "🇬🇵 Guadeloupe"
  },
  {
    value: "Gambia",
    label: "🇬🇲 Gambia"
  },
  {
    value: "Guinea-Bissau",
    label: "🇬🇼 Guinea-Bissau"
  },
  {
    value: "Equatorial Guinea",
    label: "🇬🇶 Equatorial Guinea"
  },
  {
    value: "Greece",
    label: "🇬🇷 Greece"
  },
  {
    value: "Grenada",
    label: "🇬🇩 Grenada"
  },
  {
    value: "Greenland",
    label: "🇬🇱 Greenland"
  },
  {
    value: "Guatemala",
    label: "🇬🇹 Guatemala"
  },
  {
    value: "French Guiana",
    label: "🇬🇫 French Guiana"
  },
  {
    value: "Guam",
    label: "🇬🇺 Guam"
  },
  {
    value: "Guyana",
    label: "🇬🇾 Guyana"
  },
  {
    value: "Hong Kong",
    label: "🇭🇰 Hong Kong"
  },
  {
    value: "Heard Island and McDonald Islands",
    label: "🇭🇲 Heard Island and McDonald Islands"
  },
  {
    value: "Honduras",
    label: "🇭🇳 Honduras"
  },
  {
    value: "Croatia",
    label: "🇭🇷 Croatia"
  },
  {
    value: "Haiti",
    label: "🇭🇹 Haiti"
  },
  {
    value: "Hungary",
    label: "🇭🇺 Hungary"
  },
  {
    value: "Indonesia",
    label: "🇮🇩 Indonesia"
  },
  {
    value: "Isle of Man",
    label: "🇮🇲 Isle of Man"
  },
  {
    value: "India",
    label: "🇮🇳 India"
  },
  {
    value: "British Indian Ocean Territory",
    label: "🇮🇴 British Indian Ocean Territory"
  },
  {
    value: "Ireland",
    label: "🇮🇪 Ireland"
  },
  {
    value: "Iran",
    label: "🇮🇷 Iran"
  },
  {
    value: "Iraq",
    label: "🇮🇶 Iraq"
  },
  {
    value: "Iceland",
    label: "🇮🇸 Iceland"
  },
  {
    value: "Israel",
    label: "🇮🇱 Israel"
  },
  {
    value: "Italy",
    label: "🇮🇹 Italy"
  },
  {
    value: "Jamaica",
    label: "🇯🇲 Jamaica"
  },
  {
    value: "Jersey",
    label: "🇯🇪 Jersey"
  },
  {
    value: "Jordan",
    label: "🇯🇴 Jordan"
  },
  {
    value: "Japan",
    label: "🇯🇵 Japan"
  },
  {
    value: "Kazakhstan",
    label: "🇰🇿 Kazakhstan"
  },
  {
    value: "Kenya",
    label: "🇰🇪 Kenya"
  },
  {
    value: "Kyrgyzstan",
    label: "🇰🇬 Kyrgyzstan"
  },
  {
    value: "Cambodia",
    label: "🇰🇭 Cambodia"
  },
  {
    value: "Kiribati",
    label: "🇰🇮 Kiribati"
  },
  {
    value: "Saint Kitts and Nevis",
    label: "🇰🇳 Saint Kitts and Nevis"
  },
  {
    value: "South Korea",
    label: "🇰🇷 South Korea"
  },
  {
    value: "Kosovo",
    label: "🇽🇰 Kosovo"
  },
  {
    value: "Kuwait",
    label: "🇰🇼 Kuwait"
  },
  {
    value: "Laos",
    label: "🇱🇦 Laos"
  },
  {
    value: "Lebanon",
    label: "🇱🇧 Lebanon"
  },
  {
    value: "Liberia",
    label: "🇱🇷 Liberia"
  },
  {
    value: "Libya",
    label: "🇱🇾 Libya"
  },
  {
    value: "Saint Lucia",
    label: "🇱🇨 Saint Lucia"
  },
  {
    value: "Liechtenstein",
    label: "🇱🇮 Liechtenstein"
  },
  {
    value: "Sri Lanka",
    label: "🇱🇰 Sri Lanka"
  },
  {
    value: "Lesotho",
    label: "🇱🇸 Lesotho"
  },
  {
    value: "Lithuania",
    label: "🇱🇹 Lithuania"
  },
  {
    value: "Luxembourg",
    label: "🇱🇺 Luxembourg"
  },
  {
    value: "Latvia",
    label: "🇱🇻 Latvia"
  },
  {
    value: "Macau",
    label: "🇲🇴 Macau"
  },
  {
    value: "Saint Martin",
    label: "🇲🇫 Saint Martin"
  },
  {
    value: "Morocco",
    label: "🇲🇦 Morocco"
  },
  {
    value: "Monaco",
    label: "🇲🇨 Monaco"
  },
  {
    value: "Moldova",
    label: "🇲🇩 Moldova"
  },
  {
    value: "Madagascar",
    label: "🇲🇬 Madagascar"
  },
  {
    value: "Maldives",
    label: "🇲🇻 Maldives"
  },
  {
    value: "Mexico",
    label: "🇲🇽 Mexico"
  },
  {
    value: "Marshall Islands",
    label: "🇲🇭 Marshall Islands"
  },
  {
    value: "North Macedonia",
    label: "🇲🇰 North Macedonia"
  },
  {
    value: "Mali",
    label: "🇲🇱 Mali"
  },
  {
    value: "Malta",
    label: "🇲🇹 Malta"
  },
  {
    value: "Myanmar",
    label: "🇲🇲 Myanmar"
  },
  {
    value: "Montenegro",
    label: "🇲🇪 Montenegro"
  },
  {
    value: "Mongolia",
    label: "🇲🇳 Mongolia"
  },
  {
    value: "Northern Mariana Islands",
    label: "🇲🇵 Northern Mariana Islands"
  },
  {
    value: "Mozambique",
    label: "🇲🇿 Mozambique"
  },
  {
    value: "Mauritania",
    label: "🇲🇷 Mauritania"
  },
  {
    value: "Montserrat",
    label: "🇲🇸 Montserrat"
  },
  {
    value: "Martinique",
    label: "🇲🇶 Martinique"
  },
  {
    value: "Mauritius",
    label: "🇲🇺 Mauritius"
  },
  {
    value: "Malawi",
    label: "🇲🇼 Malawi"
  },
  {
    value: "Malaysia",
    label: "🇲🇾 Malaysia"
  },
  {
    value: "Mayotte",
    label: "🇾🇹 Mayotte"
  },
  {
    value: "Namibia",
    label: "🇳🇦 Namibia"
  },
  {
    value: "New Caledonia",
    label: "🇳🇨 New Caledonia"
  },
  {
    value: "Niger",
    label: "🇳🇪 Niger"
  },
  {
    value: "Norfolk Island",
    label: "🇳🇫 Norfolk Island"
  },
  {
    value: "Nigeria",
    label: "🇳🇬 Nigeria"
  },
  {
    value: "Nicaragua",
    label: "🇳🇮 Nicaragua"
  },
  {
    value: "Niue",
    label: "🇳🇺 Niue"
  },
  {
    value: "Netherlands",
    label: "🇳🇱 Netherlands"
  },
  {
    value: "Norway",
    label: "🇳🇴 Norway"
  },
  {
    value: "Nepal",
    label: "🇳🇵 Nepal"
  },
  {
    value: "Nauru",
    label: "🇳🇷 Nauru"
  },
  {
    value: "New Zealand",
    label: "🇳🇿 New Zealand"
  },
  {
    value: "Oman",
    label: "🇴🇲 Oman"
  },
  {
    value: "Pakistan",
    label: "🇵🇰 Pakistan"
  },
  {
    value: "Panama",
    label: "🇵🇦 Panama"
  },
  {
    value: "Pitcairn Islands",
    label: "🇵🇳 Pitcairn Islands"
  },
  {
    value: "Peru",
    label: "🇵🇪 Peru"
  },
  {
    value: "Philippines",
    label: "🇵🇭 Philippines"
  },
  {
    value: "Palau",
    label: "🇵🇼 Palau"
  },
  {
    value: "Papua New Guinea",
    label: "🇵🇬 Papua New Guinea"
  },
  {
    value: "Poland",
    label: "🇵🇱 Poland"
  },
  {
    value: "Puerto Rico",
    label: "🇵🇷 Puerto Rico"
  },
  {
    value: "North Korea",
    label: "🇰🇵 North Korea"
  },
  {
    value: "Portugal",
    label: "🇵🇹 Portugal"
  },
  {
    value: "Paraguay",
    label: "🇵🇾 Paraguay"
  },
  {
    value: "Palestine",
    label: "🇵🇸 Palestine"
  },
  {
    value: "French Polynesia",
    label: "🇵🇫 French Polynesia"
  },
  {
    value: "Qatar",
    label: "🇶🇦 Qatar"
  },
  {
    value: "Réunion",
    label: "🇷🇪 Réunion"
  },
  {
    value: "Romania",
    label: "🇷🇴 Romania"
  },
  {
    value: "Russia",
    label: "🇷🇺 Russia"
  },
  {
    value: "Rwanda",
    label: "🇷🇼 Rwanda"
  },
  {
    value: "Saudi Arabia",
    label: "🇸🇦 Saudi Arabia"
  },
  {
    value: "Sudan",
    label: "🇸🇩 Sudan"
  },
  {
    value: "Senegal",
    label: "🇸🇳 Senegal"
  },
  {
    value: "Singapore",
    label: "🇸🇬 Singapore"
  },
  {
    value: "South Georgia",
    label: "🇬🇸 South Georgia"
  },
  {
    value: "Svalbard and Jan Mayen",
    label: "🇸🇯 Svalbard and Jan Mayen"
  },
  {
    value: "Solomon Islands",
    label: "🇸🇧 Solomon Islands"
  },
  {
    value: "Sierra Leone",
    label: "🇸🇱 Sierra Leone"
  },
  {
    value: "El Salvador",
    label: "🇸🇻 El Salvador"
  },
  {
    value: "San Marino",
    label: "🇸🇲 San Marino"
  },
  {
    value: "Somalia",
    label: "🇸🇴 Somalia"
  },
  {
    value: "Saint Pierre and Miquelon",
    label: "🇵🇲 Saint Pierre and Miquelon"
  },
  {
    value: "Serbia",
    label: "🇷🇸 Serbia"
  },
  {
    value: "South Sudan",
    label: "🇸🇸 South Sudan"
  },
  {
    value: "São Tomé and Príncipe",
    label: "🇸🇹 São Tomé and Príncipe"
  },
  {
    value: "Suriname",
    label: "🇸🇷 Suriname"
  },
  {
    value: "Slovakia",
    label: "🇸🇰 Slovakia"
  },
  {
    value: "Slovenia",
    label: "🇸🇮 Slovenia"
  },
  {
    value: "Sweden",
    label: "🇸🇪 Sweden"
  },
  {
    value: "Eswatini",
    label: "🇸🇿 Eswatini"
  },
  {
    value: "Sint Maarten",
    label: "🇸🇽 Sint Maarten"
  },
  {
    value: "Seychelles",
    label: "🇸🇨 Seychelles"
  },
  {
    value: "Syria",
    label: "🇸🇾 Syria"
  },
  {
    value: "Turks and Caicos Islands",
    label: "🇹🇨 Turks and Caicos Islands"
  },
  {
    value: "Chad",
    label: "🇹🇩 Chad"
  },
  {
    value: "Togo",
    label: "🇹🇬 Togo"
  },
  {
    value: "Thailand",
    label: "🇹🇭 Thailand"
  },
  {
    value: "Tajikistan",
    label: "🇹🇯 Tajikistan"
  },
  {
    value: "Tokelau",
    label: "🇹🇰 Tokelau"
  },
  {
    value: "Turkmenistan",
    label: "🇹🇲 Turkmenistan"
  },
  {
    value: "Timor-Leste",
    label: "🇹🇱 Timor-Leste"
  },
  {
    value: "Tonga",
    label: "🇹🇴 Tonga"
  },
  {
    value: "Trinidad and Tobago",
    label: "🇹🇹 Trinidad and Tobago"
  },
  {
    value: "Tunisia",
    label: "🇹🇳 Tunisia"
  },
  {
    value: "Turkey",
    label: "🇹🇷 Turkey"
  },
  {
    value: "Tuvalu",
    label: "🇹🇻 Tuvalu"
  },
  {
    value: "Taiwan",
    label: "🇹🇼 Taiwan"
  },
  {
    value: "Tanzania",
    label: "🇹🇿 Tanzania"
  },
  {
    value: "Uganda",
    label: "🇺🇬 Uganda"
  },
  {
    value: "Ukraine",
    label: "🇺🇦 Ukraine"
  },
  {
    value: "United States Minor Outlying Islands",
    label: "🇺🇲 United States Minor Outlying Islands"
  },
  {
    value: "Uruguay",
    label: "🇺🇾 Uruguay"
  },
  {
    value: "United States",
    label: "🇺🇸 United States"
  },
  {
    value: "Uzbekistan",
    label: "🇺🇿 Uzbekistan"
  },
  {
    value: "Vatican City",
    label: "🇻🇦 Vatican City"
  },
  {
    value: "Saint Vincent and the Grenadines",
    label: "🇻🇨 Saint Vincent and the Grenadines"
  },
  {
    value: "Venezuela",
    label: "🇻🇪 Venezuela"
  },
  {
    value: "British Virgin Islands",
    label: "🇻🇬 British Virgin Islands"
  },
  {
    value: "United States Virgin Islands",
    label: "🇻🇮 United States Virgin Islands"
  },
  {
    value: "Vietnam",
    label: "🇻🇳 Vietnam"
  },
  {
    value: "Vanuatu",
    label: "🇻🇺 Vanuatu"
  },
  {
    value: "Wallis and Futuna",
    label: "🇼🇫 Wallis and Futuna"
  },
  {
    value: "Samoa",
    label: "🇼🇸 Samoa"
  },
  {
    value: "Yemen",
    label: "🇾🇪 Yemen"
  },
  {
    value: "South Africa",
    label: "🇿🇦 South Africa"
  },
  {
    value: "Zambia",
    label: "🇿🇲 Zambia"
  },
  {
    value: "Zimbabwe",
    label: "🇿🇼 Zimbabwe"
  }
];
